var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShoppingBag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.2H9.75C9.75 1.432 8.29562 0 6.5 0C4.70437 0 3.25 1.432 3.25 3.2H1.625C0.73125 3.2 0 3.92 0 4.8V14.4C0 15.28 0.73125 16 1.625 16H11.375C12.2688 16 13 15.28 13 14.4V4.8C13 3.92 12.2688 3.2 11.375 3.2ZM4.875 6.4C4.875 6.84 4.50938 7.2 4.0625 7.2C3.61562 7.2 3.25 6.84 3.25 6.4V4.8H4.875V6.4ZM6.5 1.6C7.39375 1.6 8.125 2.32 8.125 3.2H4.875C4.875 2.32 5.60625 1.6 6.5 1.6ZM9.75 6.4C9.75 6.84 9.38437 7.2 8.9375 7.2C8.49063 7.2 8.125 6.84 8.125 6.4V4.8H9.75V6.4Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShoppingBag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shopping_bag.79bf0676.svg";
export { ForwardRef as ReactComponent };